import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

export interface IContactItem {
  name: string;
  jobTitle?: string;
  phone?: string;
  email?: string;
}

export interface IContactItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancel?: () => void;
  value?: Partial<IContactItem>;
  setValue?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const emptyContact = {
  name: "",
  jobTitle: "",
  phone: "",
  email: "",
} as IContactItem;
